import { useCallback } from "react";
import { useApiBase } from "../../base/api-base";

export function useGetAplicacao() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getAplicacao = useCallback(
        () => {
            return invocarApi({
                url: `/api/v2/aplicacao`,
                method: "GET",
                enviarTokenUsuario: true,
            });
        },
        [invocarApi]
    );
    return {
        ...outrasPropriedades,
        getAplicacao,
    };
}
